module.exports = __webpack_public_path__ + "static/FeatherX-4045a353244f9d24e39209a1cfa758d4.svg";